export default __webpack_public_path__ + "static/media/executive-function.7869e747.jpeg";